import React from "react";
import TextTagInput, { ITextTagInput } from "../../input/TextTagInput";
import { Box, Stack } from "@mui/material";

interface IFilterTextTag extends Omit<ITextTagInput, "onChange"> {
  placeholder?: string;
  pending?: boolean;
  onSearch?: (value: string[], merge: boolean) => void;
}

function FilterTextTag({
  label,
  defaultValue,
  placeholder,
  pending,
  toggleClear,
  onSearch,
}: IFilterTextTag) {
  return (
    <Stack direction="row" alignItems="center" gap={0.5}>
      <Box sx={{ flex: 1 }}>
        <TextTagInput
          direction="column"
          label={label}
          labelWidth="25%"
          placeholder={placeholder}
          onChange={onSearch}
          pending={pending}
          toggleClear={toggleClear}
          defaultValue={defaultValue}
        />
      </Box>
    </Stack>
  );
}

export default FilterTextTag;
